import { useQuery, UseQueryResult } from 'react-query';

import { useAuth } from 'src/hooks';
import { getAlertRevisions } from 'src/utils/urls';

import { AccountAlertResponse } from '../types/accountAlerts';

export async function fetchAlertRevisions({
  token,
  tokenType,
  accountId,
  alertId,
  revisionId,
}: TVariables): Promise<TResult | null> {
  const response = await fetch(
    getAlertRevisions(accountId, alertId, revisionId),
    {
      method: 'GET',
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    },
  );
  return response.json();
}

export type TVariables = {
  token: string;
  tokenType: string;
  accountId: number;
  alertId: number;
  revisionId: number;
};
export type TError = { message: string };
export type TResult = AccountAlertResponse;

function useGetAlertRevisions(
  accountId: number | undefined,
  alertId: number | undefined,
  revisionId: number | undefined,
  //   isEnable: boolean,
): UseQueryResult<TResult, TError> {
  const { token, tokenType } = useAuth();
  return useQuery(
    ['get_alert_revision', accountId, alertId, revisionId],
    async () => {
      if (accountId && alertId && revisionId) {
        const result = await fetchAlertRevisions({
          token,
          tokenType,
          accountId,
          alertId,
          revisionId,
        });
        return result;
      }
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      //   enabled: isEnable,
    },
  );
}

export { useGetAlertRevisions };
